var Brand = /** @class */ (function () {
    function Brand(obj, id) {
        if (id) {
            this.id = id;
        }
        this.name = obj.name;
        this.slug = obj.slug;
        this.position = obj.position;
        this.description = obj.description;
        this.logo_url = obj.logo_url;
        this.meta_title = obj.meta_title;
        this.meta_description = obj.meta_description;
        this.black_border = obj.black_border;
        this.hidden = obj.hidden;
        this.bg_seo_description = obj.bg_seo_description;
        this.en_seo_description = obj.en_seo_description;
    }
    Object.defineProperty(Brand.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "Name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "Description", {
        get: function () {
            return this.description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "LogoUrl", {
        get: function () {
            return this.logo_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "MetaTitle", {
        get: function () {
            return this.meta_title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "MetaDescription", {
        get: function () {
            return this.meta_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "BlackBorder", {
        get: function () {
            return this.black_border;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "Visible", {
        get: function () {
            return this.hidden === false ? "Публична" : "Скрита";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "BgDescriptionSEO", {
        get: function () {
            return this.bg_seo_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Brand.prototype, "EnDescriptionSEO", {
        get: function () {
            return this.en_seo_description;
        },
        enumerable: false,
        configurable: true
    });
    return Brand;
}());
export { Brand };
export function createBrand(obj, id) {
    return new Brand(obj, id);
}
export function createBrands(rawBrands) {
    var brands = [];
    var rawBrandsData = rawBrands.data;
    for (var _i = 0, rawBrandsData_1 = rawBrandsData; _i < rawBrandsData_1.length; _i++) {
        var rawBrand = rawBrandsData_1[_i];
        var brand = createBrand(rawBrand.attributes, rawBrand.id);
        brands.push(brand);
    }
    return brands;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/brand/brand.ts
// module id = 143
// module chunks = 0